export default __webpack_public_path__ + "static/media/p1050298.b58dcee1-min.e0506b7f.jpg";